import { createAction, props, union } from '@ngrx/store';

export const selectCustomer = createAction('[JobFilter] SELECT_CUSTOMER', props<{ customerId: number }>());
export const selectProject = createAction('[JobFilter] SELECT_PROJECT', props<{ projectId: number }>());
export const setFilterFormExpanded = createAction('[JobFilter] SET_FILTER_FORM_EXPANDED', props<{ expanded: boolean }>());

export const JobFilterActions = union({
  selectCustomer, selectProject, setFilterFormExpanded,
});
